import { deleteTierThunk, getTiersThunk } from '@redux/features/tier.slice';
import { AnimatedListSkeleton, AnimatedTable, AnimatedTableBody, AnimatedTableRow } from 'components/animations';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import BreadCrumb from 'Common/BreadCrumb';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import React, { FC, useEffect, useState } from 'react';
import AddTierModal from './AddTierModal';
import ButtonBase from 'components/ui/buttons/ButtonBase';
import UpdateTierModal from './UpdateTierModal';

const Tier: FC = () => {
    const [page, setPage] = useState<string>(`0`);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [showAddTierModal, setShowAddTierModal] = useState<boolean>(false);
    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
    const [tierId, setTierId] = useState<number>();

    // -------------------------------------------------------------
    const dispatch = useAppDispatch();
    // -------------------------------------------------------------
    const { tiers, loading } = useAppSelector((state: RootState) => state.tierState);
    // -------------------------------------------------------------
    const changePage = (page: string) => {
        setPage(page);
    };
    // -------------------------------------------------------------
    useEffect(() => {
        dispatch(getTiersThunk());
    }, [page]);
    // -----------------------------------------------------
    console.log(tiers);
    // -----------------------------------------------------

    const handleConfirmDelete = async () => {
        if (tierId) {
            dispatch(deleteTierThunk(tierId)).then((response: any) => {
                if (response.meta.requestStatus === 'fulfilled') {
                    setShowDeleteModal(false);
                    setTierId(undefined);
                    dispatch(getTiersThunk());
                }
            });
        }
    };

    const handleDeleteTier = (id: number) => {
        setTierId(id);
        setShowDeleteModal(true);
    };
    const handleUpdateTier = (id: number) => {
        setTierId(id);
        setShowUpdateModal(true);
    };
    // -----------------------------------------------------

    return (
        <>
            <UpdateTierModal
                show={showUpdateModal}
                handleClose={() => setShowUpdateModal(false)}
                tierId={tierId || 0}
            />
            {/* <AddTierModal handleClose={() => setShowAddTierModal(false)} show={showAddTierModal} /> */}
            <ConfirmationModal
                show={showDeleteModal}
                handleClose={() => {
                    setShowDeleteModal(false);
                    setTierId(undefined);
                }}
                onConfirm={handleConfirmDelete}
                title="Delete Tier"
                message="Are you sure you want to delete this tier? This action cannot be undone."
                confirmButtonText="Delete"
                cancelButtonText="Cancel"
                id={tierId}
            />
            <BreadCrumb pageTitle={`Tier List`} />
            <section className="py-5">
                <div className=" p-3 flex flex-col gap-2 bg-[#fff]">
                    <div className="flex w-full items-center justify-between">
                        <h3 className="font-extrabold text-[#bd902e]">Tiers List</h3>
                        {/* <ButtonBase innerText="Add Tier" onClick={() => setShowAddTierModal(true)} /> */}
                    </div>
                    {loading ? (
                        <AnimatedListSkeleton rows={8} />
                    ) : (
                        <>
                            <div>
                                <div className="overflow-x-auto">
                                    <AnimatedTable className="table-custom w-full border-separate border-spacing-y-1 whitespace-nowrap">
                                        <thead className="ltr:text-left rtl:text-right">
                                            <tr
                                                className="relative rounded-md bg-slate-50 after:absolute after:bottom-0
                    after:left-0 after:top-0 after:border-l-2
                    after:border-transparent [&.active]:after:border-custom-500"
                                            >
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">ID</th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">Tier Type</th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">
                                                    Percentage Tier
                                                </th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase text-center">
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <AnimatedTableBody loading={loading} itemCount={tiers?.length ?? 0} animationKey={`tier-${page}`}>
                                            {tiers?.map((tier: any) => (
                                                <AnimatedTableRow
                                                    rowKey={tier?.tierId}
                                                    detailRecord={tier}
                                                    className="relative rounded-md bg-slate-50 after:absolute after:bottom-0
                        after:left-0 after:top-0 after:border-l-2 hover:bg-[#bd902e10]
                        after:border-transparent [&.active]:after:border-custom-500"
                                                >
                                                    <td className="px-3.5 py-2.5">{tier?.tierId || `-`}</td>
                                                    <td className="px-3.5 py-2.5">{tier?.tierType || `-`}</td>
                                                    <td className="px-3.5 py-2.5">
                                                        {tier?.percentageTier !== undefined
                                                            ? `${tier?.percentageTier}%`
                                                            : `-`}
                                                    </td>
                                                    <td className="px-3.5 py-2.5">
                                                        <div className="flex flex-row justify-center items-center gap-2 w-full">
                                                            {/* <button
                                                                className="group flex px-4 py-2 text-xs font-semibold items-center justify-center
                                                        rounded-md border border-red-500 text-red-600
                                                        bg-white transition-all duration-300 ease-linear hover:bg-red-50 hover:border-red-600 hover:scale-105 active:scale-95"
                                                                onClick={() => {
                                                                    handleDeleteTier(tier?.tierId);
                                                                }}
                                                            >
                                                                Delete
                                                            </button> */}
                                                            <button
                                                                className={`group flex px-4 py-2 text-xs font-semibold items-center justify-center
                                                        rounded-md border transition-all duration-300 ease-linear
                                                        ${
                                                            tier?.tierType === 'NO_TIER'
                                                                ? 'border-gray-300 text-gray-400 bg-gray-50 cursor-not-allowed opacity-50'
                                                                : 'border-yellow-600 text-yellow-600 bg-white hover:bg-yellow-50 hover:border-yellow-700 hover:scale-105 active:scale-95'
                                                        }`}
                                                                onClick={() => {
                                                                    if (tier?.tierType !== 'NO_TIER') {
                                                                        handleUpdateTier(tier?.tierId);
                                                                    }
                                                                }}
                                                                disabled={tier?.tierType === 'NO_TIER'}
                                                            >
                                                                Update
                                                            </button>
                                                        </div>
                                                    </td>
                                                </AnimatedTableRow>
                                            ))}
                                        </AnimatedTableBody>
                                    </AnimatedTable>
                                </div>
                                {/* <Pagination
                                    perPageData={tiers?.totalElements}
                                    total={tiers?.totalPages}
                                    currentPage={page as unknown as number}
                                    changePage={changePage}
                                    length={tiers?.totalElements}
                                /> */}
                            </div>
                        </>
                    )}
                </div>
            </section>
        </>
    );
};

export default Tier;
